import { UserModel, OrgModel } from '../../store/storeModels/user.model';
import { HttpClient } from '@angular/common/http';
import { Endpoints } from '../../shared/config/endpoints';
import { Injectable } from '@angular/core';
import { NoteModel } from '../../models/note.model';
import { Observable, Subject, BehaviorSubject, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';

@Injectable({
  providedIn: 'root'
})
export class NoteService {
  public noteItem = new BehaviorSubject<any>('');
  private notesapi = this.endpoint.analyticsUrl;
  user;
  orgID;

  constructor(
    private endpoint: Endpoints,
    private http: HttpClient,
    store: Store<AppState>
  ) {
    store.select("userInfo").subscribe((info) => {
      this.orgID = info.organization.id;
      this.user = info.user;
    });
  }

  private _refreshNeeded$ = new Subject<void>();


  get refreshNeeded$() {
    return this._refreshNeeded$;
  }

  private getCurrDate() {
    let currDate = new Date().toLocaleDateString();
    let currTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true });
    return `${currDate}, ${currTime}`;
  }

  /**
   * create Note
   * @param form 
   */
  createNote(form: NoteModel) {
    const body = {
      assigneeID: `${form.userID}`,
      clientID: `${form.clientID || ""}`,
      clientName: `${form.clientName || ""}`,
      content: `${form.content}`,
      creatorID: `${this.user.id}`,
      dealCode: `${form.dealCode || ""}`,
      dealName: `${form.dealName || ""}`,
      orgID: `${this.orgID}`,
      teamID: `${form.teamID || ""}`,
      otherName: `${form.otherName || ""}`,
      otherID: `${form.otherID || ""}`,
    }
    return this.http.post(`${this.notesapi}/addNote`, body)
      .pipe(
        tap(() => {
          this._refreshNeeded$.next();
        })
      );
  }

  /**
   * Get Notes By User ID
   * @param id 
   */
  fetchNoteByID(id) {
    return this.http.get(`${this.notesapi}/getNote/${id}`);
  }

  /**
   * Edit Note By Id
   * @param form 
   */
  editNote(form: NoteModel) {
    const body = {
      assigneeID: `${form.assigneeID}`,
      clientID: `${form.clientID || ""}`,
      clientName: `${form.clientName || ""}`,
      content: `${form.content}`,
      createdDate: `${form.createdDate}`,
      creatorID: `${this.user.id}`,
      creatorName: `${form.creatorName}`,
      dealCode: `${form.dealCode || ""}`,
      dealName: `${form.dealName || ""}`,
      id: form.noteID,
      orgID: `${this.orgID}`,
      section: "NOTES",
      teamID: `${form.teamID}`,
      otherName: `${form.otherName || ""}`,
      otherID: `${form.otherID || ""}`,
    }
    return this.http.post(`${this.notesapi}/updateNote`, body);
  }

  deleteNoteByID(noteID) {
    return this.http.delete(`${this.notesapi}/Note/${noteID}/${this.user.id}`);
  }

  /**
   * Get Notes By Id and Type
   * @param Ids (Users/Supervisor Ids, Team Id, Deal Code,Client Id)
   * @param type (1,2,3,4)
   */
  getNotes(Ids, type): Observable<NoteModel[]> {
    return this.http.get<NoteModel[]>(`${this.notesapi}/getNotes/${Ids}/${type}/${this.orgID}`);
  }
  getRecentNoteActivity(dealCode): Observable<any> {
    return this.http.get(`${this.notesapi}/getRecentActivityNotes/${dealCode}`).pipe(map((notesTasks: any) => {
      return notesTasks && notesTasks ? notesTasks.data : [];
      ;
    }))
  }
}
